import Customer from './Customer';
import CustomerProvider from './CustomerContext';

let Index = () => {
    return (
        <CustomerProvider>
            <Customer />
        </CustomerProvider>
    )
}

export default Index;